import { Cloud, Droplets, Wind } from 'lucide-react';

interface DayForecastProps {
  date: string;
  maxTemp: number;
  minTemp: number;
  condition: string;
  windSpeed: number;
  precipitation: number;
  icon: string;
}

export function DayForecast({ 
  date, 
  maxTemp, 
  minTemp, 
  condition, 
  windSpeed, 
  precipitation,
  icon 
}: DayForecastProps) {
  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <div className="text-center mb-4">
        <p className="text-lg font-semibold text-gray-700">{date}</p>
      </div>
      
      <div className="flex items-center justify-center mb-4">
        <img 
          src={`https:${icon}`} 
          alt={condition} 
          className="w-16 h-16"
        />
      </div>

      <div className="text-center mb-4">
        <p className="text-2xl font-bold">{maxTemp}°C</p>
        <p className="text-gray-600">Min: {minTemp}°C</p>
        <p className="text-gray-600">{condition}</p>
      </div>

      <div className="flex justify-between text-sm text-gray-600">
        <div className="flex items-center gap-1">
          <Wind className="w-4 h-4" />
          <span>{windSpeed} m/s</span>
        </div>
        <div className="flex items-center gap-1">
          <Droplets className="w-4 h-4" />
          <span>{precipitation}%</span>
        </div>
      </div>
    </div>
  );
}